import * as React from "react";
import { useEffect,useState } from "react";
import {
  DataGrid,
  GridRowsProp,
  GridColDef,
  faIR,
  GridToolbar,
  GridViewStreamIcon,
} from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import { Box, Grid, IconButton, Button } from "@mui/material";
import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AcUnitTwoToneIcon from "@mui/icons-material/CallToAction";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AttachmentIcon from "@mui/icons-material/Attachment";
import { GridSortModel } from '@mui/x-data-grid';

import { setinitialStateR } from "../../../components/Login/LoginSlice/LoginSlice";
import "./style.css";
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";

//  export default function CustomToolbarGrid() {
//       const { data } = useDemoData({
//         dataSet: 'Commodity',
//         rowLength: 10,
//         maxColumns: 6,
//       });
// setShowToolbarModal={setShowModal}
// showInformation={showModal}

export default function DyDataGrid({
  data = [],
  columns = [],
  hideFooter,
  selectionModel,
  initialOnRowClick,
  rowSelection,
  rowHeight,
  onRowSelectionEvent,
  initState,
  setSelectionModel,
  setShowHistory,
  setShowAttachment,
  additionalToolbar,
  setShowInformation,
  setSpecialId,
  setShowAddEvalModal,
  setShoowCommitmentsModal,
  setShoowCommitmentsModal1,
  setShowActionsModal,
  initialMount,
  setPointSys,
  drName,
  setRowSelectedData,
  withoutOptions,
}: any) {
  const [selectedRowData, setSelectedRowData] = React.useState(null);
  const [columnVisibilityModel, setColumnVisibilityModel] = useState(() => {
    const savedVisibility = localStorage.getItem('columnVisibility');
    const defaultVisibility = {
      problems: false, 
      rowidd: false, 
      description: false, 
      commentt: false, 
      // rowid: false, 
      okR_KeyResultType: false, 
      weight: false, 
      okrStateName: false, 
      pointingSystemType: false, 
      oneValue: false, 
      oldNextState: false, 
      oldState: false, 
      threeTenthsValue: false, 
      startDate: false, 
      forceEndDate: false, 
      revenueTwo: false, 
      revenue: false, 
      score: false, 
      currentValue: false, 
      nextState: false, 
      name: false, 
      measurementUnit: false, 
      reportingPeriod: false, 
      startValue: false, 
      sevenTenthsValue: false, 
    };

    // اگر داده‌ای در localStorage موجود باشد آن را بازیابی می‌کند، در غیر این صورت مقادیر پیش‌فرض را برمی‌گرداند
    return savedVisibility ? JSON.parse(savedVisibility) : defaultVisibility;
  });
  
  const handleColumnVisibilityChange = (newModel: any) => {
    setColumnVisibilityModel(newModel);
    // ذخیره مدل جدید در localStorage
    localStorage.setItem('columnVisibility', JSON.stringify(newModel));
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <Grid>
          {selectedRowData && additionalToolbar && (
            <Button
              sx={{ fontSize: "10px" }}
              variant="text"
              onClick={() => {
                setShowHistory((prev: any) => !prev);
                let { id } = selectedRowData;
                setSpecialId(id);
              }}
              startIcon={<HistoryToggleOffIcon />}
            >
              تاریخچه
            </Button>
          )}
          {selectedRowData && additionalToolbar && (
            <Button
              sx={{ fontSize: "10px" }}
              variant="text"
              onClick={() => {
                setShowAttachment((prev: any) => !prev);
                let { id } = selectedRowData;
                setSpecialId(id);
              }}
              startIcon={<AttachmentIcon />}
            >
              ضمیمه
            </Button>
          )}
          {selectedRowData && additionalToolbar && (
            <Button
              sx={{ fontSize: "10px" }}
              variant="text"
              onClick={() => {
                setShowInformation((prev: any) => !prev);
                console.log(selectedRowData);
                initialOnRowClick(selectedRowData);
                // console.log('run')
              }}
              startIcon={<ReceiptLongIcon />}
            >
              اطلاعات
            </Button>
          )}
          
          {selectedRowData && additionalToolbar && (
            <Button
              sx={{ fontSize: "10px" }}
              variant="text"
              onClick={() => {
                setShoowCommitmentsModal((prev: any) => !prev);
                let { id } = selectedRowData;
                setSpecialId(id);
              }}
              startIcon={<AssignmentIcon />}
            >
              تعهدات
            </Button>
          )}
          {selectedRowData && additionalToolbar && (
            <Button
              sx={{ fontSize: "10px" }}
              variant="text"
              onClick={() => {
                setShoowCommitmentsModal1((prev: any) => !prev);
                let { id } = selectedRowData;
                setSpecialId(id);
              }}
              startIcon={<GridViewStreamIcon />}
            >
              درخواست/پیشنهاد همکاری
            </Button>
          )}
          {selectedRowData && additionalToolbar && (
            <Button
              sx={{ fontSize: "10px" }}
              variant="text"
              onClick={() => {
                setShowAddEvalModal((prev: any) => !prev);
                let { id } = selectedRowData;
                setSpecialId(id);
              }}
              startIcon={<EditNoteOutlinedIcon />}
            >
              ارزیابی قبل جلسه
            </Button>
          )}
          {/* {selectedRowData && additionalToolbar && (
            <Button
              sx={{ fontSize: "10px" }}
              variant="text"
              onClick={() => {
                setShowActionsModal((prev: any) => !prev);
                let { id } = selectedRowData;
                setSpecialId(id);
              }}
              startIcon={<AcUnitTwoToneIcon />}
            >
          اقدامات
            </Button>
          )} */}
        </Grid>
        <GridToolbarColumnsButton sx={{ display: { xs: 'none', sm: 'inline-flex' } }} />
<GridToolbarFilterButton sx={{ display: { xs: 'none', sm: 'inline-flex' } }} />
<GridToolbarDensitySelector sx={{ display: { xs: 'none', sm: 'inline-flex' } }} />

        {/* <GridToolbarExport /> */}
      </GridToolbarContainer>
    );
  }

  const initOnRowClick = (row: any) => {
    // console.log(pram)
    // console.log(row.api.getAllRowIds().indexOf(row.id)+1)
    // params.api.getAllRowIds().indexOf(params.id)+1
    setSelectionModel(row.id);

    setSelectedRowData(row);

    initialOnRowClick(row);
    if (setPointSys) {
      setPointSys(row?.okR_KeyResultType);
    }

    if (setRowSelectedData) {
      setRowSelectedData(row);
    }
  };

  useEffect(() => {
    // console.log("dataLoad", data);

    if (initialMount) {
      setSelectedRowData(data[0]);
      // setSelectionModel(data[0]?.id)
      initialOnRowClick(data[0]);
    }

    if (setPointSys) {
      setPointSys(data[0]?.okR_KeyResultType);
    }

    if (setRowSelectedData) {
      setRowSelectedData(data[0]);
    }
  }, []);

  const dispatch = useDispatch();
  const [sortModel, setSortModel] = useState<GridSortModel>([]);

  const initialChangestate = (data: any) => {
    // console.log("data", data);
    if (drName && data) {
      let columnVisibilityModel = data?.columns?.columnVisibilityModel;

      try {
        dispatch(
          setinitialStateR({ name: drName, colVis: columnVisibilityModel })
        );
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <Grid width={"100%"}>
                  <div style={{ height: 220, width: '100%' }}> {/* ارتفاع و عرض محدود شده */}

    <DataGrid
      onStateChange={(state) => {
        initialChangestate(state);
      }}
      density="compact"
      initialState={initState}
      slots={{ toolbar: withoutOptions ? null : CustomToolbar }}
      rowHeight={40}
      sx={{
        cursor: "pointer",
        border: 0,
        "& .MuiDataGrid-columnSeparator": {
          display: "none!important",
        },
        "& .MuiDataGrid-root": {
          backgroundColor: "#00387C !important",
          color: "white",
          borderRadius: 4,
          cursor: "pointer",
          border: 0,
          "& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell": {
            fontSize: "10px",
          },
          "& .rtl-128fb87-MuiDataGrid-toolbarContainer": {
            alignSelf: "end",
            pb: 2,
          },
        },
        "& .MuiDataGrid-columnHeaders": {
          width: "100%",
          position: "sticky",
          zIndex: "1000",
          background: "#00387C !important",
          color: "white",
          borderRadius: 0,
        },
        // "& .MuiDataGrid-row:nth-of-type(odd)": {
        //   backgroundColor: "#f5f5f5",  // رنگ پس‌زمینه برای سطرهای فرد
        // },
        // "& .MuiDataGrid-row:nth-of-type(even)": {
        //   backgroundColor: "#ffffff",  // رنگ پس‌زمینه برای سطرهای زوج
        // },
      }}
      hideFooter={hideFooter}
      autoHeight={false}
      localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
      rowSelectionModel={selectionModel}
      rows={data ? data : []}
      columns={columns}
      columnVisibilityModel={columnVisibilityModel} // تنظیم مدل نمایش ستون‌ها
      onColumnVisibilityModelChange={handleColumnVisibilityChange}
      // disableColumnMenu
      checkboxSelection={rowSelection ? rowSelection : false}
      rowSelection={true}
      onRowClick={(param) => {
        initOnRowClick(param.row);
      }}
      // getRowClassName={(params) =>
      //  selectedRowData ? '' : 'selected-row'
      // }
      sortModel={sortModel}  // Added for sorting
      onSortModelChange={(model) => setSortModel(model)} // Added to handle sort changes
    />
                </div>

  </Grid>
  );
}
// import * as React from "react";
// import { useEffect } from "react";
// import {
//   DataGrid,
//   GridRowsProp,
//   GridColDef,
//   faIR,
//   GridToolbar,
// } from "@mui/x-data-grid";
// import { useDispatch, useSelector } from "react-redux";
// import { Box, Grid, IconButton, Button } from "@mui/material";
// import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";
// import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
// import AcUnitTwoToneIcon from "@mui/icons-material/CallToAction";
// import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
// import { setinitialStateR } from "../../../components/Login/LoginSlice/LoginSlice";
// import "./style.css";
// import {
//   GridToolbarContainer,
//   GridToolbarColumnsButton,
//   GridToolbarFilterButton,
//   GridToolbarExport,
//   GridToolbarDensitySelector,
// } from "@mui/x-data-grid";

//  export default function CustomToolbarGrid() {
//       const { data } = useDemoData({
//         dataSet: 'Commodity',
//         rowLength: 10,
//         maxColumns: 6,
//       });
// setShowToolbarModal={setShowModal}
// showInformation={showModal}

// export default function DyDataGrid({
//   data = [],
//   columns = [],
//   hideFooter,
//   selectionModel,
//   initialOnRowClick,
//   rowSelection,
//   rowHeight,
//   onRowSelectionEvent,
//   initState,
//   setSelectionModel,
//   setShowHistory,
//   additionalToolbar,
//   setShowInformation,
//   setSpecialId,
//   setShowAddEvalModal,
//   setShowActionsModal,
//   initialMount,
//   setPointSys,
//   drName,
//   setRowSelectedData,
//   withoutOptions,
// }: any) {
//   const [selectedRowData, setSelectedRowData] = React.useState(null);
//   function CustomToolbar() {
//     return (
//       <GridToolbarContainer>
//         <Grid>
//           {selectedRowData && additionalToolbar && (
//             <Button
//               sx={{ fontSize: "10px" }}
//               variant="text"
//               onClick={() => {
//                 setShowHistory((prev: any) => !prev);
//                 let { id } = selectedRowData;
//                 setSpecialId(id);
//               }}
//               startIcon={<HistoryToggleOffIcon />}
//             >
//               تاریخچه
//             </Button>
//           )}
//           {selectedRowData && additionalToolbar && (
//             <Button
//               sx={{ fontSize: "10px" }}
//               variant="text"
//               onClick={() => {
//                 setShowInformation((prev: any) => !prev);
//                 console.log(selectedRowData);
//                 initialOnRowClick(selectedRowData);
//                 // console.log('run')
//               }}
//               startIcon={<ReceiptLongIcon />}
//             >
//               اطلاعات
//             </Button>
//           )}
//           {/* {selectedRowData && additionalToolbar && (
//             <Button
//               sx={{ fontSize: "10px" }}
//               variant="text"
//               onClick={() => {
//                 setShowAddEvalModal((prev: any) => !prev);
//                 let { id } = selectedRowData;
//                 setSpecialId(id);
//               }}
//               startIcon={<EditNoteOutlinedIcon />}
//             >
//               ارزیابی قبل جلسه
//             </Button>
//           )} */}

//       {selectedRowData && additionalToolbar && (
//         <Button
//           sx={{ fontSize: "10px" }}
//           variant="text"
//           onClick={() => {
//             setShowAddEvalModal((prev: any) => !prev);
//             let { id } = selectedRowData;
//             setSpecialId(id);
//           }}
//           startIcon={<EditNoteOutlinedIcon />}
//         >
//           ارزیابی قبل جلسه
//         </Button>
//       )}
//           {/* {selectedRowData && additionalToolbar && (
//             <Button
//               sx={{ fontSize: "10px" }}
//               variant="text"
//               onClick={() => {
//                 setShowActionsModal((prev: any) => !prev);
//                 let { id } = selectedRowData;
//                 setSpecialId(id);
//               }}
//               startIcon={<AcUnitTwoToneIcon />}
//             >
//           اقدامات
//             </Button>
//           )} */}
//         </Grid>
//         <GridToolbarColumnsButton />
//         <GridToolbarFilterButton />
//         <GridToolbarDensitySelector />
//         {/* <GridToolbarExport /> */}
//       </GridToolbarContainer>
//     );
//   }

//   const initOnRowClick = (row: any) => {
//     // console.log(pram)
//     // console.log(row.api.getAllRowIds().indexOf(row.id)+1)
//     // params.api.getAllRowIds().indexOf(params.id)+1
//     setSelectionModel(row.id);

//     setSelectedRowData(row);

//     initialOnRowClick(row);
//     if (setPointSys) {
//       setPointSys(row?.okR_KeyResultType);
//     }

//     if (setRowSelectedData) {
//       setRowSelectedData(row);
//     }
//   };

//   useEffect(() => {
//     // console.log("dataLoad", data);

//     if (initialMount) {
//       setSelectedRowData(data[0]);
//       // setSelectionModel(data[0]?.id)
//       initialOnRowClick(data[0]);
//     }

//     if (setPointSys) {
//       setPointSys(data[0]?.okR_KeyResultType);
//     }

//     if (setRowSelectedData) {
//       setRowSelectedData(data[0]);
//     }
//   }, []);

//   const dispatch = useDispatch();

//   const initialChangestate = (data: any) => {
//     // console.log("data", data);
//     if (drName && data) {
//       let columnVisibilityModel = data?.columns?.columnVisibilityModel;

//       try {
//         dispatch(
//           setinitialStateR({ name: drName, colVis: columnVisibilityModel })
//         );
//       } catch (error) {
//         console.log(error);
//       }
//     }
//   };

//   return (
//     <Grid width={"100%"}>
//       <DataGrid
//         onStateChange={(state) => {
//           initialChangestate(state);
//         }}
//         density="compact"
//         initialState={initState}
//         slots={{ toolbar: withoutOptions ? null : CustomToolbar }}
//         rowHeight={40}
//         sx={{
//           cursor: "pointer",
//           border: 0,
//           "& .MuiDataGrid-columnSeparator": {
//             display: "none!important",
//           },
//           "& .MuiDataGrid-root": {
//             backgroundColor: "#00387C !important",
//             color: "white",
//             borderRadius: 4,
//             cursor: "pointer",
//             border: 0,
//             "& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell": {
//               fontSize: "10px", // Adjust the font size as needed
//             },
//             "& .rtl-128fb87-MuiDataGrid-toolbarContainer": {
//               alignSelf: "end",
//               pb: 2,
//             },
//           },
//           "& .MuiDataGrid-columnHeaders": {
//             width: "100%",
//             position: "sticky",
//             zIndex: "1000",
//             background: "#00387C !important",
//             color: "white",
//             borderRadius:0

//           },
//         }}
//         hideFooter={hideFooter}
//         autoHeight
//         localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
//         rowSelectionModel={selectionModel}
//         rows={data ? data : []}
//         columns={columns}
//         disableColumnMenu
//         // disableColumnFilter
//         checkboxSelection={rowSelection ? rowSelection : false}
//         rowSelection={true}
//         onRowClick={(param) => {
//           initOnRowClick(param.row);
//         }}
//         // cell
//       />
//     </Grid>
//   );
// }

